"use strict";

module.exports = {
    "search2": {
        "search-button-text": "Cari",
        "search-input-label": "Permintaan",
        "search-service-label": "Cari layanan",
        "search-web-label": "Pencarian Web"
    }
};